import { Breadcrumb, Heading, TextLink } from "@hawkins/components";

import { AppLayout } from "../../layout/AppLayout/AppLayout.tsx";
import { Loader } from "../../utils/Loader/Loader.tsx";
import { PdfViewer } from "../../utils/PdfViewer/PdfViewer.tsx";
import { useDocumentByPageUrl } from "../../../hooks/useDocumentByPageUrl.ts";
import { useGlobalContext } from "../../../utils/GlobalContext.ts";

import styles from "./SynopsisPage.module.scss";

const SYNOPSIS_PAGE_URL = "synopsis";

export const SynopsisPage = () => {
  const { localeConfig } = useGlobalContext();
  const { document, loading, notFound, error } =
    useDocumentByPageUrl(SYNOPSIS_PAGE_URL);

  const pdfUrl = document?.file?.url ?? null;
  const title = document?.documentTitle ?? document?.file?.title ?? "Synopsis";

  return (
    <AppLayout>
      <div className={styles.contentWrapper}>
        {!loading && (error || notFound || !pdfUrl) ? (
          <div className={styles.error} role="alert">
            Unable to load the synopsis document. Please try again later.
          </div>
        ) : (
          <>
            {loading ? (
              <Loader fullBlock={true} text="Loading synopsis..." />
            ) : (
              <div className={styles.viewerContainer}>
                <Breadcrumb>
                  <TextLink
                    href={`/${localeConfig?.currentLocale?.toLowerCase() || ""}`}
                  >
                    Back to home page
                  </TextLink>
                  <TextLink>Synopsis</TextLink>
                </Breadcrumb>
                <Heading level={4} className={styles.title}>
                  {title}
                </Heading>
                {!loading && !error && !notFound && pdfUrl && (
                  <PdfViewer src={pdfUrl} ariaLabel={title} />
                )}
              </div>
            )}
          </>
        )}
      </div>
    </AppLayout>
  );
};
